import { IApplicationState } from '../../types/redux';

export const selectAddFormLink = (state: IApplicationState) => state.newOfferForm.url;
